import React from "react";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { OnboardingOptInTemplate } from "@limitless/content";
import {
    useExpertOnboardingOptInContentHook,
    useExpertOnboardingQuizContentHook,
    useExpertOnboardingBrandLearningContentHook
} from "@limitless/expert";
import OnboardingContainer from "../components/containers/onboarding-container/OnboardingContainer";
import { useNavigation } from "@limitless/portal";
import ExpertBrandLearningScreen from "./ExpertBrandLearningScreen";
import { usePageViewRecorder } from "@limitless/analytics";
import { ExpertMultiChoiceQuizDialog } from "./ExpertMultiChoiceQuizDailog";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";

const ExpertOptInScreen = () => {
    const { onboardingOptInContent, optInGroup } = useExpertOnboardingOptInContentHook();
    const { t } = useTranslation();
    usePageViewRecorder("Onboarding - Onboarding Opt-In");

    const {
        handleCloseDailog,
        showBrandLearningPage,
        multipleChoiceQuizModalOpen,
        handleQuizTryAgainSuccessClick,
        handleBrandLearningCtaClick,
        handleOptInCtaClick,
        updateSelectedAnswer,
        isAllowToSubmitAnswers,
        submitQuiz,
        quizState,
        quizTryAgainSuccessContent,
        handleChangeOnboardingInvitationStatus,
        onboardingMcQuizContent
    } = useExpertOnboardingQuizContentHook(t);
    const { onboardingBrandLearningContent } = useExpertOnboardingBrandLearningContentHook();

    const { navigate } = useNavigation();
    const theme = useCustomTheme();

    React.useEffect(() => {
        if (!optInGroup) {
            navigate("/onboarding");
        }
    }, []);

    React.useEffect(() => {
        if (quizState.forwardToActive) {
            handleChangeOnboardingInvitationStatus(navigate)(true);
        }
    }, [quizState]);

    const { loading, template } = onboardingOptInContent;

    return (
        <ThemeProvider theme={theme}>
            <React.Fragment>
                {!showBrandLearningPage ? (
                    <OnboardingContainer loading={loading} disableTitle>
                        {template && !showBrandLearningPage ? (
                            <OnboardingOptInTemplate
                                content={onboardingOptInContent}
                                optInCtaClick={handleOptInCtaClick(navigate)}
                            />
                        ) : (
                            <div />
                        )}
                    </OnboardingContainer>
                ) : (
                    <ExpertBrandLearningScreen
                        ctaClick={handleBrandLearningCtaClick(navigate)}
                        content={onboardingBrandLearningContent}
                    />
                )}
                {multipleChoiceQuizModalOpen && (
                    <ExpertMultiChoiceQuizDialog
                        open={multipleChoiceQuizModalOpen}
                        handleCloseDailog={handleCloseDailog}
                        onboardingMcQuizContent={onboardingMcQuizContent}
                        quizTryAgainSuccessContent={quizTryAgainSuccessContent}
                        handleQuizTryAgainSuccessClick={handleQuizTryAgainSuccessClick}
                        updateSelectedAnswer={updateSelectedAnswer}
                        isAllowToSubmitAnswers={isAllowToSubmitAnswers}
                        submitQuiz={submitQuiz}
                        quizState={quizState}
                    />
                )}
            </React.Fragment>
        </ThemeProvider>
    );
};

export default ExpertOptInScreen;
